import template   from './header.html'
import controller from './header.controller'
import './header.styl'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/common/header/header.component.js